import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Variant } from '../models';

@Component({
  selector: 'app-buy-buttons',
  templateUrl: './buy-buttons.component.html',
  styleUrls: ['./buy-buttons.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BuyButtonsComponent implements OnInit {
  @Input() variant: Variant;

  constructor() { }

  ngOnInit() { }

  buyOn(website: string) {
    const url = this.variant.getShopUrl(website);
    window.open(url, '_blank');
  }
}



// WEBPACK FOOTER //
// ./src/app/fonzi-module/buy-buttons/buy-buttons.component.ts